export const devinoEn = {
	devino: {
		ariaLabel: {
			backspace: 'Backspace',
			cell: 'Letter {{position}}, {{letter}}, {{state}}',
			close: 'Close',
			grid: 'Word guessing grid',
			keyboard: 'Virtual keyboard',
			page: 'Devino word game',
		},
		ariaLive: {
			absent: 'absent',
			correct: 'correct',
			guessRow: 'Row {{row}}: {{result}}',
			loss: 'Game over. The word was {{word}}.',
			misplaced: 'misplaced',
			win: 'Congratulations! You found the word in {{count}} attempts.',
		},
		customWord: {
			buttonLabel: 'Make your own',
			copied: 'Copied!',
			copyLink: 'Copy link',
			generateLink: 'Generate link',
			inputLabel: 'Enter a word',
			inputPlaceholder: 'Type a word...',
			invalidLength: 'Word must be 5, 6, 7 or 8 letters',
			invalidWord: 'Word must contain only letters',
			modalTitle: 'Make your own Devino',
			play: 'Play',
		},
		error: {
			wrongLength: 'Word must be {{count}} letters',
		},
		gameOver: {
			lossTitle: 'Better luck next time',
			lossWord: 'The word was:',
			playAgain: 'Play Again',
			winSubtitle: 'You found the word in {{count}}/6',
			winTitle: 'Congratulations!',
		},
		header: {
			backLink: 'Portfolio',
			help: 'How to play',
			settings: 'Settings',
			title: 'DEVINO',
		},
		howToPlay: {
			absentDesc: '<strong>{{letters}}</strong> are not in the word.',
			correctDesc:
				'<strong>{{letter}}</strong> is in the word and in the correct position.',
			examples: 'Examples',
			gotIt: 'Got it!',
			intro1: 'Guess the hidden word in 6 attempts.',
			intro3:
				'After each guess, the color of the tiles will change to show how close your guess was.',
			misplacedDesc:
				'<strong>{{letter}}</strong> is in the word but in the wrong position.',
			rule3: 'You can change word length and language in Settings',
			rules: 'Rules',
			title: 'How To Play',
		},
		input: {
			hintLost: 'Better luck next time!',
			hintPlaying: 'Type your guess...',
			hintWon: 'You found the word!',
		},
		keyboard: {
			enter: 'ENTER',
		},
		settings: {
			keyboardLayout: 'Keyboard Layout',
			language: 'Language',
			resetWarning: 'Current game will be reset',
			title: 'Settings',
			wordLength: 'Word Length',
		},
	},
}
